import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
} from "@angular/core";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { ActivatedRoute, Router } from "@angular/router";
import { MultiFilesService } from "../../../services/multifiles.service";
import { NotificationService } from "../../../services/notification.service";
import { FolderService } from "../../../services/folder.service";
import { Methods } from "../../methods";
import { HttpEventType, HttpResponse } from "@angular/common/http";
import { Lightbox } from "ngx-lightbox";
import swal from "sweetalert2";
import JSZip from "jszip";
import * as FileSaver from "file-saver";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";

@Component({
  selector: "app-multi-files",
  templateUrl: "./multi-files.component.html",
  styleUrls: ["./multi-files.component.css"],
  providers: [NotificationService],
})
export class MultiFilesComponent implements OnInit {
  public mtds: Methods = new Methods();
  public filesCita = [];
  progressInfos = [];
  selectedFiles: FileList;
  message = "";
  identity;
  @Input() readonly = false;
  @Input() idfather = null;
  @Input() idson = null;
  @Input() type = "";
  @Input() typeson = "";
  @Input() title = "Attached files";
  @Input() source = "";
  @Input() poNumber = "";
  @Input() canDelete = true;
  @Input() disabled = false;
  @Output() fileUrlChange = new EventEmitter<string>();

  @Output() total: EventEmitter<number> = new EventEmitter();
  @Input() fileUrl: EventEmitter<any> = new EventEmitter();
  ngOnChanges(changes: SimpleChanges) {
    if (changes["idfather"]) {
      console.log("Nuevo idfather recibido:", this.idfather);
      // Ejecutar lógica necesaria
    }
  }
  @Output() totalChange = new EventEmitter<number>();

  private _album: Array<any> = [];
  public token;

  jsonHeader = "application/json; odata=verbose";
  headersOld = new Headers({
    "Content-Type": this.jsonHeader,
    Accept: this.jsonHeader,
  });
  headers = { "Content-Type": this.jsonHeader, Accept: this.jsonHeader };

  constructor(
    private httpClient: HttpClient,
    private _router: Router,
    private uploadService: MultiFilesService,
    private _notificationService: NotificationService,
    private _folderService: FolderService,
    private _lightbox: Lightbox
  ) {
    this.identity = JSON.parse(localStorage.getItem("identity"));
  }

  ngOnInit() {
    this.token = JSON.parse(localStorage.getItem("token"));

    if (this.type === "FILESBATCH")
      this.title = "Drop Erasure Certificate to Complete the Process";

    //console.log(this.idfather);
    this.uploadService
      .getFiles(this.token, this.idfather, this.type)
      .subscribe((response) => {
        //console.log(response);
        if (
          response.code === 400 &&
          response.msg === "Authorization not valid"
        ) {
          this.mtds.notifyError("Your session has expired");
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        } else if (response.status == "success") {
          response.data.map((file) => {
            this.filesCita.push(file);
          });
          this.total.emit(this.filesCita.length);
        }

        if (this.idson) {
          this.uploadService
            .getFiles(this.token, this.idson, this.typeson)
            .subscribe((r2) => {
              console.log(r2);
              if (r2.code === 400 && r2.msg === "Authorization not valid") {
                this.mtds.notifyError("Your session has expired");
                localStorage.clear();
                this._router.navigate(["/pages/lock"]);
              } else if (r2.status == "success") {
                r2.data.map((file) => {
                  this.filesCita.push(file);
                });
                this.total.emit(this.filesCita.length);
              }
            });
        }
      });
  }

  getFileUrl(fileCita: any): string {
    if (fileCita.folder == "hasoft") {
      return `${fileCita.file}`;
    } else if (this.type === "MyLeadFiles" && this.source == "Website") {
      return `https://www.greenteksolutionsllc.com/uploads/mails/${fileCita.file}`;
    } else if (this.type === "MyLeadFiles" && this.source == "MXWebsite") {
      return `https://www.greenteksolutions.mx/uploads/mails/${fileCita.file}`;
    } else {
      return `https://ha-software.com/backend/${fileCita.folder}/${fileCita.file}`;
    }
  }

  // fileimagescount(): number {
  //   return  this.filesCita.filter(
  //     file => file.file.includes('.jpg') || file.file.includes(".jpeg") || file.file.includes(".png")
  //   ).length;
  // }

  download() {
    const images = this.filesCita.map((file) => {
      if (file.folder == "hasoft") return `${file.file}`;
      else return `https://ha-software.com/backend/${file.folder}/${file.file}`;
    });

    console.log(images);
    this.createZip(images, `${this.type}-${this.idfather}`);
  }

  copyfiletoerasureport(file){


      swal
      .fire({
        title: "",
        text: "Are you sure you want to send this file to CV files?",

        showCancelButton: true,
        buttonsStyling: false,

        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-default",
        },
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes",
      })
      .then(
        function (result) {
          if (result.value) {
             this._folderService.copyToErasureReports(this.token, file).subscribe(
              (response) => {
                if (
                  response.code === 400 &&
                  response.msg === "Authorization not valid"
                ) {
                  this.mtds.notifyError("Your session has expired");
                  localStorage.clear();
                  this._router.navigate(["/pages/lock"]);
                } else if (response.status == "success") {
                 
                  this.mtds.notifySuccess("File has been copied to the folder");
                } else {
                  this.mtds.notifyError(response.msg, response.code);
                }
              },
              (error) => {
                this.mtds.notifyError(error.statusText, error.status);
              }
            );
          }
        }.bind(this)
      );


    

   

  }

  async createZip(files: any[], zipName: string) {
    const zip = new JSZip();
    const name = zipName + ".zip";
    // tslint:disable-next-line:prefer-for-of
    for (let counter = 0; counter < files.length; counter++) {
      const element = files[counter];
      const fileData: any = await this.getFile(element);
      const b: any = new Blob([fileData], { type: "" + fileData.type + "" });
      zip.file(element.substring(element.lastIndexOf("/") + 1), b);
    }
    zip.generateAsync({ type: "blob" }).then((content) => {
      if (content) {
        FileSaver.saveAs(content, name);
      }
    });
  }

  async getFile(url: string) {
    const httpOptions = {
      responseType: "blob" as "json",
    };
    const res = await this.httpClient
      .get(url, httpOptions)
      .toPromise()
      .catch((err: HttpErrorResponse) => {
        const error = err.error;
        return error;
      });
    return res;
  }

  onDropped(event: CdkDragDrop<any>) {
    moveItemInArray(this.filesCita, event.previousIndex, event.currentIndex);
  }

  delete(id) {
    swal
      .fire({
        title: "Remove File",
        text: "Are you sure to delete this file?",

        showCancelButton: true,
        buttonsStyling: false,

        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: "btn btn-default",
        },
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Continue",
      })
      .then(
        function (result) {
          if (result.value) {
            this.uploadService.removeFile(this.token, id).subscribe(
              (response) => {
                if (
                  response.code === 400 &&
                  response.msg === "Authorization not valid"
                ) {
                  this.mtds.notifyError("Your session has expired");
                  localStorage.clear();
                  this._router.navigate(["/pages/lock"]);
                } else if (response.status == "success") {
                  let idx = 0;
                  for (let file of this.filesCita) {
                    if (file.id === id) {
                      this.filesCita.splice(idx, 1);
                      this.total.emit(this.filesCita.length);
                      break;
                    }
                    idx++;
                  }
                  this.mtds.notifySuccess("File has been removed");
                } else {
                  this.mtds.notifyError(response.msg, response.code);
                }
              },
              (error) => {
                this.mtds.notifyError(error.statusText, error.status);
              }
            );
          }
        }.bind(this)
      );
  }

  selectFiles(event) {
    this.progressInfos = [];
    this.selectedFiles = event.target.files;

    this.uploadFiles(event);
  }

  uploadFiles(event) {
    let me = this;
    this.message = "";
    console.log(
      "uploadFiles this.selectedFiles.length => ",
      this.selectedFiles.length
    );
    let userName = this.identity.name + " " + this.identity.surname;
    console.log("this.idfather => ", this.idfather);

    //creamos notification backend
    let typenot = "";
    if (this.type == "FILESPROCESSING") {
      typenot = "PONEWFILE";
      let text_not = "";
      if (this.selectedFiles.length > 1)
        text_not =
          this.selectedFiles.length +
          " files have been added to PO# " +
          this.poNumber +
          " by " +
          userName;
      else
        text_not =
          this.selectedFiles.length +
          " file has been added to PO# " +
          this.poNumber +
          " by " +
          userName;
      let jsonnot = {
        type: typenot,
        idElement: this.idfather,
        action: "NEW",
        poNumberNot: this.poNumber,
        texto: text_not,
      };
      this._notificationService.newManual(me.token, jsonnot).subscribe();
    }
    //creamos notification backend
    for (let i = 0; i < this.selectedFiles.length; i++) {
      this.upload(i, this.selectedFiles[i]);
    }
  }

  onFileUploaded(url) {
    this.fileUrlChange.emit(url);
  }

  upload(idx, file) {
    let me = this;
    this.progressInfos[idx] = { value: 0, fileName: file.name };

    this.uploadService.upload(file, this.idfather, this.type).subscribe(
      (event) => {
        // console.log(event);
        if (event.type === HttpEventType.UploadProgress) {
          this.progressInfos[idx].value = Math.round(
            (100 * event.loaded) / event.total
          );
        } else if (event instanceof HttpResponse) {
          //console.log(event);
          let newfile = {
            fatherId: this.idfather,
            fecha: event.body.message.fehca,
            file: event.body.message.file,
            folder: "uploads/" + event.body.message.folder,
            id: event.body.message.id,
            name: this.identity.name,
            surname: this.identity.surname,
            type: this.type,
            userId: Number(event.body.message.userId),
          };
          this.filesCita.push(newfile);
          this.onFileUploaded(newfile);
          console.log(newfile.file, "this is my file");
          this.total.emit(this.filesCita.length);
          //creamos notification backend
          let typenot = "";
          /*if(this.type == 'FILESPROCESSING'){
            typenot = 'PONEWFILE';
            let jsonnot = {"type":typenot, "idElement": this.idfather, "action":"NEW", "poNumberNot":event.body.message.poNumber};
            this._notificationService.newManual(me.token, jsonnot).subscribe();
          } else*/ if (this.type == "PICKUPNEWPHOTOS") {
            let jsonnot = {
              type: this.type,
              idElement: this.idfather,
              action: "NEW",
              poNumberNot: "",
            };
            this._notificationService.newManual(me.token, jsonnot).subscribe();
          }
          //creamos notification backend
        }
      },
      (err) => {
        this.progressInfos[idx].value = 0;
        this.message = "Could not upload the file:" + file.name;
      }
    );
  }

  lightboxOpen(file_id) {
    this._album = [];
    let i = 1,
      index = 0;
    for (let doc of this.filesCita) {
      if (
        doc.file.includes(".png") ||
        doc.file.includes(".jpg") ||
        doc.file.includes(".jpeg")
      ) {
        const src =
          "https://ha-software.com/backend/" + doc.folder + "/" + doc.file;
        const caption = doc.file;
        const thumb =
          "https://ha-software.com/backend/" + doc.folder + "/" + doc.file;
        const album = {
          src: src,
          caption: caption,
          thumb: thumb,
        };

        this._album.push(album);
        if (file_id === doc.id) {
          index = i - 1;
        }
        i++;
      }
    }

    this._lightbox.open(this._album, index);
  }

  lightboxClose() {
    this._lightbox.close();
  }

  tipo(doc) {
    if (
      doc.includes(".xlsx") ||
      doc.includes(".xlsm") ||
      doc.includes(".xlsb") ||
      doc.includes(".xltx") ||
      doc.includes(".xltm") ||
      doc.includes(".xls") ||
      doc.includes(".xlt") ||
      doc.includes(".xml") ||
      doc.includes(".xlam") ||
      doc.includes(".xla") ||
      doc.includes(".xlw") ||
      doc.includes(".xlr")
    ) {
      return "excel";
    }

    if (
      doc.includes(".prn") ||
      doc.includes(".txt") ||
      doc.includes(".csv") ||
      doc.includes(".dif") ||
      doc.includes(".slk")
    ) {
      return "texto";
    }

    if (doc.includes(".pdf")) {
      return "pdf";
    }

    if (doc.includes(".jpg") || doc.includes(".jpeg") || doc.includes(".png")) {
      return "imagen";
    }

    if (
      doc.includes(".docx") ||
      doc.includes(".docm") ||
      doc.includes(".dotx") ||
      doc.includes(".dotm")
    ) {
      return "word";
    }

    if (
      doc.includes(".pptx") ||
      doc.includes(".pptm") ||
      doc.includes(".potx") ||
      doc.includes(".potm") ||
      doc.includes(".ppam") ||
      doc.includes(".ppsx") ||
      doc.includes(".ppsm") ||
      doc.includes(".sldx") ||
      doc.includes(".sldm") ||
      doc.includes(".thmx")
    ) {
      return "powerpoint";
    }

    if (doc.includes(".zip") || doc.includes(".rar")) {
      return "zip";
    }

    return "otro";
  }
}
